'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('@apollo/client');
var error = require('@apollo/client/link/error');
var apolloClientFactory = require('@narvar/apollo-client');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var apolloClientFactory__default = /*#__PURE__*/_interopDefaultLegacy(apolloClientFactory);

const createErrorLog = handleError => error.onError(_ref => {
  let {
    graphQLErrors,
    networkError,
    operation
  } = _ref;
  if (graphQLErrors) {
    graphQLErrors.forEach(_ref2 => {
      let {
        message,
        locations,
        path
      } = _ref2;
      return handleError(`[GraphQL error]: OperationName: ${operation.operationName} Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${JSON.stringify(path)}, Variables: ${JSON.stringify(operation.variables)}`);
    });
  }
  if (networkError) {
    const {
      response
    } = networkError;
    handleError(`[GraphQL network error]: OperationName: ${operation.operationName} Message: ${JSON.stringify(networkError)}${response ? `, Headers: ${JSON.stringify([...response.headers.entries()])}` : ''}`);
  }
});
async function createClient(_ref3) {
  let {
    uri,
    handleError,
    links
  } = _ref3;
  const {
    client: client$1,
    startCacheTtlChecker
  } = await apolloClientFactory__default["default"]({
    fetch,
    uri,
    ssrMode: false,
    addTypename: true,
    maxBatch: 20,
    disablePersistedCache: true,
    // tell apollo to merge non-normalized cache objects, which was a breaking change in apollo v3
    // https://www.apollographql.com/docs/react/caching/cache-field-behavior/#merging-non-normalized-objects
    typePolicies: {
      RetailerTranslations: {
        merge: true
      },
      RetailerSettings: {
        merge: true
      },
      RetailerTheme: {
        merge: true
      },
      GlobalSettings: {
        merge: true
      }
    },
    link: _ref4 => {
      let {
        retry,
        batch,
        rest
      } = _ref4;
      return client.from([rest, retry, ...(links ?? []), createErrorLog(handleError), batch]);
    }
  });
  startCacheTtlChecker();
  return client$1;
}
const useLomaClient = _ref5 => {
  let {
    lomaUrl,
    handleError,
    links
  } = _ref5;
  const [state, setState] = React.useState({});
  React.useEffect(() => {
    createClient({
      uri: lomaUrl,
      handleError,
      links
    }).then(client => setState({
      client
    }), error => setState({
      error
    }));
  }, [lomaUrl, handleError, links]);
  return state;
};

exports["default"] = useLomaClient;
